module.exports = {
      id: "blue-sale-usage",
      viewBox: "0 0 34 12",
      url: __webpack_public_path__ + "sprite-d2a4e8aaeb47684d6d07571fc646b0db.svg#blue-sale",
      toString: function () {
        return this.url;
      }
    }